export const SET_EVENT_VIEW = 'SET_EVENT_VIEW'
export const SET_EVENT_CATEGORY = 'SET_EVENT_CATEGORY'
export const SET_EVENT_DATE = 'SET_EVENT_DATE'

export const setView = view => dispatch => {
  dispatch({ type: SET_EVENT_VIEW, payload: view })
}

export const setCategory = category => dispatch => {
  dispatch({ type: SET_EVENT_CATEGORY, payload: category })
}

export const setDate = date => dispatch => {
  dispatch({ type: SET_EVENT_DATE, payload: date })
}
